import { SVGProps } from 'react';

const LifebuoyScaleSmall = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_525_24)">
            <path
                d="M5.64313 5.64299L3.28612 3.28598M3.28612 12.7141L5.64315 10.357M10.3572 10.357L12.7142 12.714M12.7142 3.28595L10.3572 5.64298M14.6668 8.00001C14.6668 11.6819 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8.00001C1.3335 4.31811 4.31826 1.33334 8.00016 1.33334C11.6821 1.33334 14.6668 4.31811 14.6668 8.00001ZM11.3335 8.00001C11.3335 9.84096 9.84111 11.3333 8.00016 11.3333C6.15921 11.3333 4.66683 9.84096 4.66683 8.00001C4.66683 6.15906 6.15921 4.66668 8.00016 4.66668C9.84111 4.66668 11.3335 6.15906 11.3335 8.00001Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.33333}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_525_24">
                <rect width={16} height={16} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default LifebuoyScaleSmall;
